/**
 * created by hezq on 2019年03月28日
 *
 * description： 配置文件
 *
 */

let config = {
  // 项目名称
  projectName: 'platform',
  // 域名前缀标识
  platFlag: 'Market',
  // 系统id
  subsystem: 'S00000',
  // 平台编码，由基础服务配置产生
  ssid: 'M11140',
  // 商机订阅ssid
  subssid: 'M00008',
  // 兵器电商平台电子招投标系统与辅助评标系统接口地址前缀
  apiPath: '//hyqy.norincogroup-ebuy.com/msapi/appmkweb',
  // 商机订阅地址
  subscribePath: '//hyqy.norincogroup-ebuy.com/msapi/subweb',
  // bs基础平台接口地址前缀
  basePath: '//bsapi.norincogroup-ebuy.com/baseInvoker',
  // sso地址
  ssoPath: '$$_SSOPATH_$$',
  // 会员权益服务地址
  memberPath: '//hyqy.norincogroup-ebuy.com/msapi/chargesweb',
  // 会员微服务
  API_MB: '//msapi.norincogroup-ebuy.com/menberweb',
  //招投标业务地址
  bdPath: '//bid.norincogroup-ebuy.com',
	//招投标新版业务地址
	bdNewPath: '//bid.norincogroup-ebuy.com/bidweb',
  // 登录地址配置
  loginPath: '//bs.norincogroup-ebuy.com/login/bdIndex.do',
  // domain配置
  domain: '.norincogroup-ebuy.com',
  // 发票地址
  invoicePath: '//hyqy.norincogroup-ebuy.com/msapi/mbcweb',
  // 地区地址
  addressPath: '//hyqy.norincogroup-ebuy.com/msapi/bsmweb',
  // 跟踪关注地址
  concernPath: '//hyqy.norincogroup-ebuy.com/msapi/trackweb',
  // 支付地址
  payPath: '//bdbk.norincogroup-ebuy.com/psmbank',
  // 权限申请地址
  qxPath: '//bs.norincogroup-ebuy.com/bsp/menber/jsxz/list.do?qxrole=008',
  // 文件图片地址
  filePath: '//file.norincogroup-ebuy.com',
  // 重新开票发票服务地址
  invoicePath2: '//hyqy.norincogroup-ebuy.com/msapi/invoiceweb',
  // 错误日志服务地址
  logPath: '//hyqy.norincogroup-ebuy.com/msapi/lgweb',
  // 错误日志服务地址
  hyqycmsPath: '//hyqy.norincogroup-ebuy.com',
  // 基础门户地址
  bsCmsPath: '/hyqycms',
  // 服务端接口报错默认提示
  serverErrorMessage: '服务内部错误',
  // 未登录或登录失效默认提示
  nologinErrorMessage: '未登录或登录失效，请重新登录',
  // 请求接口无权限默认提示
  noAuthErrorMessage: '请求无权限',
  // 专属经理电话
  exclusiveManagerPhone: '010-21240558',
  // 活动页缓存
  activity: 'ACTIVITY20210101'
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/libs/config.js